import type { ReactNode } from 'react'

interface Props {
    cargando: boolean
    error: string | null
    vacio?: boolean
    mensajeVacio?: string
    alReintentar?: () => void
    children: ReactNode
}

/** Envuelve el contenido de una pantalla con sus estados de carga, error y vacio. */
export function Estado({ cargando, error, vacio, mensajeVacio, alReintentar, children }: Props) {
    if (cargando) {
        return (
            <div className="fila centro" style={{ padding: 'var(--e6)' }}>
                <span className="cargando" aria-label="Cargando" />
            </div>
        )
    }

    if (error) {
        return (
            <div className="aviso aviso-error columna g3" role="alert">
                <span>{error}</span>
                {alReintentar && (
                    <button type="button" className="boton" onClick={alReintentar}>
                        Reintentar
                    </button>
                )}
            </div>
        )
    }

    if (vacio) {
        return <p className="vacio">{mensajeVacio ?? 'No hay nada que mostrar.'}</p>
    }

    return <>{children}</>
}
